"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DataService = require("../DataService");

var _index = require("./index");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Takes a redux ACTION_NAME and returns an with additional keys
 * and action handlers using the standard FetchUtils.
 *
 * @param {string} actionName The action name to use
 * @param {bool}   isDelete Signals to use `mergeDelete` instead of `mergeSuccess`.
 * @param {string} bucket The reduced state to look at.
 *
 * @return {Object} A new object with the keys {ACTION_NAME}, {ACTION_NAME_SUCCESS}, {ACTION_NAME_ERROR}
 */
var createActionHandlers = function createActionHandlers(actionName) {
  var _ref;

  var isDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var bucket = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'objects';
  return _ref = {}, _defineProperty(_ref, actionName, function (state, action) {
    return (0, _index.mergeLoading)(state, action);
  }), _defineProperty(_ref, "".concat(actionName).concat(_DataService.ActionStates.SUCCESS), isDelete ? function (state, action) {
    return (0, _index.mergeDelete)(state, action, bucket);
  } : function (state, action) {
    return (0, _index.mergeSuccess)(state, action, bucket);
  }), _defineProperty(_ref, "".concat(actionName).concat(_DataService.ActionStates.ERROR), function _(state, action) {
    return (0, _index.mergeError)(state, action);
  }), _ref;
};

var _default = createActionHandlers;
exports["default"] = _default;